import axios from "axios"
import { CSRF_TOKEN } from '../constants/csrfToken';
import { getTransactionId } from "./transactionId";

/**
 * call api to get the csrf oken
 * @return  {object}          Api response
 */
export const getCSRFToken = (activationFlow = "Pre-Activation") =>
{
  const url = CSRF_TOKEN.apiUrl
  return axios.request({
    method: 'GET',
    url,
    withCredentials: true,
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      "X-Transaction-ID": getTransactionId(),
      "X-Activation-Flow": activationFlow,
    }
  })
}
